export const sortByNewestFirst = (a, b) => {
  const aDate = new Date(a.created_at)
  const bDate = new Date(b.created_at)

  return bDate - aDate
}
